/** Own every preview URL and revoke it when its source or result leaves the queue. */
export class ObjectURLs {
  private urls = new Map<Blob, string>();
  get(blob: Blob): string { let url = this.urls.get(blob); if (!url) { url = URL.createObjectURL(blob); this.urls.set(blob, url); } return url; }
  retain(blobs: Iterable<Blob>): void { const wanted = new Set(blobs); for (const [blob, url] of this.urls) if (!wanted.has(blob)) { URL.revokeObjectURL(url); this.urls.delete(blob); } }
  clear(): void { this.retain([]); }
}
export function download(blob: Blob, name: string): void {
  const url = URL.createObjectURL(blob), anchor = document.createElement('a');
  anchor.href = url; anchor.download = name; document.body.append(anchor); anchor.click(); anchor.remove();
  // Some engines consume the URL after click dispatch; release after that handoff.
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
}
